import { createContext } from "react";

const NotificationContext = createContext();
NotificationContext.displayName = "NotificationContext";

export default NotificationContext;
